import { useRef, useState } from "react";
import { toast } from "sonner";
import { Images, X } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

const PARALLEL = 3;

export const BulkImageUpload = ({ onDone }) => {
  const input = useRef(null);
  const [run, setRun] = useState(null);
  const pick = async (e) => {
    const files = [...(e.target.files || [])];
    e.target.value = "";
    if (!files.length) return;
    const state = { total: files.length, done: 0, ok: 0, errors: [] };
    setRun({ ...state });
    const queue = [...files];
    const worker = async () => {
      for (let f = queue.shift(); f; f = queue.shift()) {
        try {
          if (f.size > 8 * 1024 * 1024) throw new Error("oltre 8 MB");
          const fd = new FormData();
          fd.append("file", f);
          await api.post("/admin/products/image-by-sku", fd);
          state.ok += 1;
        } catch (err) {
          state.errors.push(`${f.name}: ${err.response ? formatApiError(err) : err.message}`);
        }
        state.done += 1;
        setRun({ ...state, errors: [...state.errors] });
      }
    };
    await Promise.all(Array.from({ length: PARALLEL }, worker));
    toast.success(`${state.ok} foto caricate`, { description: state.errors.length ? `${state.errors.length} file non abbinati` : "Foto principali aggiornate" });
    onDone?.();
  };
  const busy = run && run.done < run.total;
  return (
    <span className="relative">
      <button type="button" disabled={busy} onClick={() => input.current?.click()} className="flex items-center gap-1.5 rounded-full border-2 border-black/20 px-3 py-1.5 text-xs font-semibold disabled:opacity-50" data-testid="bulk-images-open">
        <Images className="h-3.5 w-3.5" />Foto in blocco (nome file = SKU o EAN)
      </button>
      <input ref={input} type="file" multiple accept="image/jpeg,image/png,image/webp,image/gif" onChange={pick} className="hidden" data-testid="bulk-images-file" />
      {run && (
        <div className="absolute left-0 z-30 mt-2 w-80 rounded-2xl border-2 border-black bg-white p-4 text-sm shadow-[4px_4px_0_#000]" data-testid="bulk-images-panel">
          <div className="flex items-center justify-between"><b>{busy ? "Caricamento foto..." : "Caricamento completato"}</b>{!busy && <button onClick={() => setRun(null)} data-testid="bulk-images-close"><X className="h-4 w-4" /></button>}</div>
          <div className="mt-2 h-2 overflow-hidden rounded-full bg-black/10"><div className="h-full bg-amber-500 transition-[width]" style={{ width: `${(run.done / run.total) * 100}%` }} data-testid="bulk-images-progress" /></div>
          <p className="mt-1 text-xs text-stone-600" data-testid="bulk-images-status">{run.done} di {run.total} · {run.ok} abbinate · {run.errors.length} errori</p>
          {!!run.errors.length && <ul className="mt-2 max-h-32 overflow-auto text-xs text-rose-700" data-testid="bulk-images-errors">{run.errors.map((x) => <li key={x}>{x}</li>)}</ul>}
          <p className="mt-2 text-xs text-stone-500">La foto caricata diventa la principale; quella precedente resta tra le foto aggiuntive.</p>
        </div>
      )}
    </span>
  );
};
